// TODO fill out all of the promotion methods here
import {fetchLineItemDiscount, fetchTicketDiscount} from "./cart-helper";

export const PROMOTION_TYPES = {
  TICKET: 0,
  PRODUCT: 1,
  CATEGORY: 2,
};

/**
 * This fetches the product discount
 *
 * @param promotion
 * @param lineItems
 */
export function attachPromotionDiscount(
  promotion,
  lineItems,
  discounts,
  params = {}
) {
  const {debug = false} = params;

  if (promotion.TYPE === PROMOTION_TYPES.TICKET) {
    const ticketDiscount = fetchTicketDiscount({promotion});

    if (debug) {
      console.log("PUSHING TICKET DISCOUNT TO DISCOUNTS", ticketDiscount);
    }

    discounts.push(ticketDiscount);
    return;
  } else if (
    promotion.TYPE === PROMOTION_TYPES.PRODUCT ||
    promotion.TYPE === PROMOTION_TYPES.CATEGORY
  ) {
    let maxDiscount = 0,
      maxIdx = 0,
      currIdx = 0,
      maxDiscountObj = null;

    for (const lineItem of lineItems) {
      if (
        lineItem.TYPE === "PRODUCT" &&
        (promotion.PRODUCTS.includes(parseInt(lineItem.OBJECT_ID)) ||
          promotion.CATEGORIES.includes(lineItem.product.CATEGORY_ID))
      ) {
        if (!promotion.ONCE_PER_ORDER) {
          const promotionLineItemDiscount = fetchLineItemDiscount({
            promotion: promotion,
          });

          if (debug) {
            console.log(
              "PUSHING LINE ITEM DISCOUNT (MANY_PER_ORDER)",
              promotionLineItemDiscount
            );
          }

          lineItem.DISCOUNTS.push(promotionLineItemDiscount);
        } else {
          const promotionLineItemDiscount = fetchLineItemDiscount({
            promotion: promotion,
          });

          const currDisc = _getRoughDiscountAmount(
            promotionLineItemDiscount,
            lineItem
          );

          if (currDisc > maxDiscount) {
            maxDiscount = currDisc;
            maxIdx = currIdx;

            maxDiscountObj = promotionLineItemDiscount;
          }
        }
      }

      currIdx += 1;
    }

    if (promotion.ONCE_PER_ORDER && maxDiscountObj) {
      if (debug) {
        console.log(
          "PUSHING LINE ITEM DISCOUNT (ONE_PER_ORDER)",
          maxDiscountObj,
          maxIdx
        );
      }

      lineItems[maxIdx].DISCOUNTS.push(maxDiscountObj);
    }
  }
}

export function removePromotionDiscount(
  promotion,
  lineItems,
  discounts,
  params = {debug: false}
) {
  const {debug = false} = params;

  if(debug) {
    console.log("REMOVE", promotion, lineItems, discounts);
  }

  if (promotion.TYPE === PROMOTION_TYPES.TICKET) {
    const discIndexes = discounts.reduce((accum, item, index) => {
      if (item.PROMOTION_ID === promotion.ID) {
        accum.unshift(index);
      }

      return accum;
    }, []);

    if(debug) {
      console.log("REMOVING", discIndexes, discounts);
    }

    if (discIndexes.length > 0) {
      for (const idx of discIndexes) {
        discounts.splice(idx, 1);
      }
    }
  } else if (
    promotion.TYPE === PROMOTION_TYPES.PRODUCT ||
    promotion.TYPE === PROMOTION_TYPES.CATEGORY
  ) {
    for (const lineItem of lineItems.filter(
      (_item) => _item.TYPE === "PRODUCT"
    )) {
      if (lineItem.DISCOUNTS) {

        if(debug) {
          console.log("FILTER", lineItem);
        }

        lineItem.DISCOUNTS = lineItem.DISCOUNTS.filter((disc) => {
          return disc.PROMOTION_ID !== promotion.ID;
        });
      }
    }

    if(debug) {
      console.log("REMOVED", lineItems);
    }

  }
}

export function fetchPromotionDiscount(items, promotion) {
  if (promotion.TYPE === PROMOTION_TYPES.TICKET) {
    const ticketDiscount = fetchTicketDiscount({promotion});

    discounts.push(ticketDiscount);
    return;
  } else if (
    promotion.TYPE === PROMOTION_TYPES.PRODUCT ||
    promotion.TYPE === PROMOTION_TYPES.CATEGORY
  ) {
    let maxDiscount = 0,
      maxIdx = 0,
      currIdx = 0,
      maxDiscountObj = null;

    for (const lineItem of lineItems) {
      if (
        lineItem.TYPE === "PRODUCT" &&
        (promotion.PRODUCTS.includes(parseInt(lineItem.OBJECT_ID)) ||
          promotion.CATEGORIES.includes(lineItem.product.CATEGORY_ID))
      ) {
        if (!promotion.ONCE_PER_ORDER) {
          const promotionLineItemDiscount = fetchLineItemDiscount({
            promotion: promotion,
          });

          if (debug) {
            console.log(
              "PUSHING LINE ITEM DISCOUNT (MANY_PER_ORDER)",
              promotionLineItemDiscount
            );
          }

          lineItem.DISCOUNTS.push(promotionLineItemDiscount);
        } else {
          const promotionLineItemDiscount = fetchLineItemDiscount({
            promotion: promotion,
          });

          const currDisc = _getRoughDiscountAmount(
            promotionLineItemDiscount,
            lineItem
          );

          if (currDisc > maxDiscount) {
            maxDiscount = currDisc;
            maxIdx = currIdx;

            maxDiscountObj = promotionLineItemDiscount;
          }
        }
      }

      currIdx += 1;
    }

    if (promotion.ONCE_PER_ORDER && maxDiscountObj) {
      if (debug) {
        console.log(
          "PUSHING LINE ITEM DISCOUNT (ONE_PER_ORDER)",
          maxDiscountObj,
          maxIdx
        );
      }

      lineItems[maxIdx].DISCOUNTS.push(maxDiscountObj);
    }
  }
}

function _getRoughDiscountAmount(lineItemDiscount, lineItem) {
  // This isn't exactly right since discounts are applied in a certain order with new cart
  // This just assumes this discount is last to be applied, so if there are other discounts
  // on the items it may not pick the exact right max discount amount every time.

  if (lineItemDiscount.PERCENT_AMOUNT !== null) {
    return Math.round(lineItem.AMOUNT * (1 / lineItemDiscount.PERCENT_AMOUNT));
  } else {
    return Math.min(lineItemDiscount.AMOUNT, lineItem.AMOUNT);
  }
}

export function isValidPromotion(items, promotion, productDict = {}) {
  if (promotion.TYPE === PROMOTION_TYPES.TICKET) {
    return true;
  } else if (promotion.TYPE === PROMOTION_TYPES.PRODUCT) {
    const productSet = new Set(promotion.PRODUCTS);

    for (let item of items) {
      if (item.OBJECT_ID === null) {
        continue;
      }

      if (productSet.has(parseInt(item.OBJECT_ID))) {
        return true;
      }
    }
  } else if (promotion.TYPE === PROMOTION_TYPES.CATEGORY) {
    const categorySet = new Set(promotion.CATEGORIES);

    for (let item of items) {
      if (item.OBJECT_ID === null) {
        continue;
      }

      const shopProduct = productDict[item.OBJECT_ID];

      if (shopProduct && categorySet.has(shopProduct.CATEGORY_ID)) {
        return true;
      }
    }
  }

  return false;
}

export function isValidItemPromotion(item, promotion, productDict) {
  if (promotion.TYPE === PROMOTION_TYPES.TICKET) {
    return true;
  } else if (promotion.TYPE === PROMOTION_TYPES.PRODUCT) {
    const productSet = new Set(promotion.PRODUCTS);

    if (item.OBJECT_ID === null) {
      return false;
    }

    return productSet.has(parseInt(item.OBJECT_ID));
  } else if (promotion.TYPE === PROMOTION_TYPES.CATEGORY) {
    const categorySet = new Set(promotion.CATEGORIES);
    const shopProduct = productDict[item.OBJECT_ID];

    return shopProduct && categorySet.has(shopProduct.CATEGORY_ID);
  } else {
    return false;
  }
}

function _parseIdDict(arr) {
  var key =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ID";
  return arr.reduce(function (dict, item) {
    dict[item[key]] = item;
    return dict;
  }, {});
}
